<script lang="ts">
import app from 'vue3-runtime-template/App.vue'
import { useConfigStore } from '~/store'

type GenericApplicationData = PildomModules.Generic.Data.GenericApplicationData

export default {
    name: 'DefaultLayout',
    setup() {
        const configStore = useConfigStore()

        return {
            configStore,
        }
    },
    computed: {
        app() {
            return app
        },
        currentPage() {
            return this.$currentPath(this.$route.matched[0].path).pop()
            // return this.$refs && this.$refs.MenuBreadcrumbs && this.$refs.MenuBreadcrumbs.breadcrumbItems.slice(-1)
        },
        appInfoData(): GenericApplicationData | null {
            const nuxtApp = useNuxtApp()
            const config = nuxtApp.vueApp.$nuxt.$pinia.state._value.config?.currentConfig
            return config?.app_info
        },
        loading(): boolean {
            return useConfigStore()?.globalLoading
        },

        maintenance() {
            return useConfigStore()?.maintenance
        },

    },
    mounted() {
        useConfigStore().setGlobalLoading(false)
        this.configStore.currentConfig.homepage_view = 'connexion'
    },
}
</script>

<template>
    <v-layout>
        <MenuGlobalLoader :loading="loading">
            <template #loader>
                <svg viewBox="25 25 50 50">
                    <circle
                        class="loader-path"
                        cx="50"
                        cy="50"
                        r="20"
                        fill="none"
                        stroke="#636363"
                        stroke-width="2"
                    />
                </svg>
            </template>
            <template #logo />
        </MenuGlobalLoader>

        <MenuMaintenanceMessage>
            <template #logo />
        </MenuMaintenanceMessage>

        <client-only>
            <v-main
                v-if="!maintenance && !loading"
                id="main-content"
                class="bg-custom-light"
            >
                <header>
                    <MenuAppBar :disable-navigation="true">
                        <template v-if="appInfoData" #title>
                            <v-row align="center">
                                <v-col cols="3" md="3" lg="2" class="text-center">
                                    <img
                                        :alt="appInfoData.title"
                                        height="70"
                                        class="w-auto pt-1 logo"
                                        :src="`${$config.public.apiBase}/${appInfoData.icon}`"
                                        @click="$router.push(`/${appInfoData.slug}`)"
                                    >
                                </v-col>
                                <v-col v-if="$vuetify.display.mdAndUp" cols="9">
                                    {{ appInfoData.title }}
                                    <v-chip
                                        v-if="appInfoData.status === 'down'"
                                        size="small" color="warning"
                                        class="mr-1"
                                    >
                                        En maintenance
                                    </v-chip>
                                </v-col>
                            </v-row>
                        </template>
                        <template #rightMenu>
                            <MenuAppbarUserProfile login-color="light">
                                <template #loginbuttons>
                                    <v-btn
                                        class="mx-2"
                                        variant="outlined"
                                        @click="configStore.currentConfig.homepage_view = 'connexion'"
                                    >
                                        Connexion
                                    </v-btn>
                                    <v-btn
                                        class="mx-2"
                                        variant="outlined"
                                        @click="configStore.currentConfig.homepage_view = 'register'"
                                    >
                                        Créer un compte
                                    </v-btn>
                                </template>
                            </MenuAppbarUserProfile>
                        </template>
                    </MenuAppBar>
                </header>
                <div
                    id="page-content" class="pa-6"
                >
                    <slot />
                    <Toaster />
                </div>
                <MenuFooter color="primary" />
            </v-main>
        </client-only>
    </v-layout>
</template>
